/**
 * Define the allowed theme types
 */
export type TsStyleThemeTypes
  = 'primary'
  | 'accent'
  | 'warn'
;

/**
 * An array of the allowed {@link TsStyleThemeTypes} for checking values
 */
export const tsStyleThemeTypesArray: TsStyleThemeTypes[] = ['primary', 'accent', 'warn'];
